<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2481 3.75C7.3608 3.75 4.20953 6.90126 4.20953 10.7885C4.20953 14.6758 7.3608 17.8271 11.2481 17.8271C15.1354 17.8271 18.2866 14.6758 18.2866 10.7885C18.2866 6.90126 15.1354 3.75 11.2481 3.75ZM2.20953 10.7885C2.20953 5.79669 6.25623 1.75 11.2481 1.75C16.2399 1.75 20.2866 5.79669 20.2866 10.7885C20.2866 13.0337 19.468 15.0877 18.113 16.6683L22.7046 21.2479L21.2922 22.664L16.6512 18.035C15.144 19.1606 13.2739 19.8271 11.2481 19.8271C6.25623 19.8271 2.20953 15.7804 2.20953 10.7885Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
